export enum ActionTypes {
    FETCH_LOGS = 'logs-module/fetch-logs',
}
